<template>
  <div>
    <table class="table is-striped is-narrow is-hoverable is-bordered is-fullwidth">
      <thead>
      <tr>
        <th>&nbsp;</th>
        <th>File Name</th>
        <th v-if="showUpdated">Last Updated</th>
        <th>Type</th>
        <th v-if="canDelete"></th>
      </tr>
      </thead>
      <tbody>
      <tr v-if="documents.length === 0 && !isLoading">
        <td colspan="6" class="has-text-centered">
          There are currently no documents to be listed
        </td>
      </tr>
      <tr v-else-if="documents.length === 0 && isLoading">
        <td colspan="6" class="has-text-centered">
          <font-awesome-icon icon="spinner" spin v-show="isLoading"  /> Fetching your list of documents
        </td>
      </tr>

      <tr is="table-row" v-for="(document, index) in documents" :show-updated="showUpdated" :can-delete="canDelete" :key="document.documentKey" v-model="documents[index]" @deleted="silentFetch">
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import TableRow from './row'
import { mapGetters, mapState, mapActions } from 'vuex'
import DocumentsApi from '@/api-interface/document'

export default {
  name: 'CompanyDocumentsTable',

  props: {
    accountKey: {
      type: String
    },
    companyJobKey: {
      type: String
    },
    companyKey: {
      type: String
    },
    companyJobFreightKey: {
      type: String
    },

    canDelete: {
      type: Boolean,
      default: true
    },
    showUpdated: {
      type: Boolean,
      default: true
    }
  },

  async created() {
    this.fetch()
  },

  components: {
    TableRow
  },

  data() {
    return {
      isLoading: false,
      nonCompanyDocuments: []
    }
  },

  methods: {
    ...mapActions('companyDocuments', { fetchDocuments: 'fetch' }),

    /**
     * Fetch an updated list of documents w/o showing any indicators to the user
     * @returns {Promise<void>}
     */
    async silentFetch() {
      this._fetch()
    },

    /**
     * Fetch documents and show loading indicators
     * @returns {Promise<void>}
     */
    async fetch() {
      this.isLoading = true
      try {
        await this._fetch()
      } catch (error) {
        console.log('Error loading company library files', error)
      } finally {
        this.isLoading = false
      }
    },

    /**
     *  Method that actually does the fetch work.
     *  Calls the proper API based on the entityType
     *
     * @returns {Promise<void>}
     * @private
     */
    async _fetch() {
      if (this.entityType === 'currentCompanyLibrary') {
        await this.fetchDocuments()
      } else {
        const params = {}
        params[this.entityType] = this.entityKey
        this.nonCompanyDocuments = await DocumentsApi.list(params)
      }
    }
  },

  computed: {
    ...mapGetters('user', ['accountInfo']),
    ...mapState('companyDocuments', { currentCompanyLib: 'list' }),

    documents() {
      let docs = []
      if (this.entityType === 'currentCompanyLibrary') {
        docs = this.currentCompanyLib
      } else if (this.nonCompanyDocuments.length) {
        docs = this.nonCompanyDocuments
      }

      return docs
    },

    entityKey() {
      return this.companyKey || this.companyJobKey || this.companyJobFreightKey || this.accountKey
    },

    /**
     * The type of entity that needs to be fetched based on the prop passed in.
     * If no prop is given... assume the current company library
     * @returns {string}
     */
    entityType() {
      let entity = 'currentCompanyLibrary'

      if (this.companyJobKey) {
        entity = 'companyJobKey'
      } else if (this.companyKey) {
        entity = 'companyKey'
      } else if (this.companyJobFreightKey) {
        entity = 'companyJobFreightKey'
      } else if (this.accountKey) {
        entity = 'accountKey'
      }

      return entity
    }
  }
}
</script>

<style scoped>
.button {
  margin: 0 3px;
}
</style>
